import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'hour4u-admin-trial-ended-popup',
  templateUrl: './trial-ended-popup.component.html',
  styleUrls: ['./trial-ended-popup.component.scss']
})
export class TrialEndedPopupComponent implements OnInit {

  constructor(public dialogRef: MatDialogRef<TrialEndedPopupComponent>) { }

  ngOnInit() {
  }

  closePopup() {
    this.dialogRef.close(true);
  }

  subscribePlan() {
    this.dialogRef.close(true);
  }
}
